/**
 * Client-side currency helper functions
 */

import { getCurrenciesSync, getAllCurrencies } from './currencyService';

// Function to get currencies (for components that need async loading)
export const getSupportedCurrencies = async () => {
  const currencies = await getAllCurrencies();
  // Transform to match the old format (code, name) for backward compatibility
  return currencies.map(c => ({
    code: c.code,
    name: c.name || c.code
  }));
};

// Function to get currencies synchronously (uses cache)
export const getSupportedCurrenciesSync = () => {
  const currencies = getCurrenciesSync();
  // Transform to match the old format (code, name) for backward compatibility
  return currencies.map(c => ({
    code: c.code,
    name: c.name || c.code
  }));
};
